import { useState } from "react";
import { api } from "../../services/apiService";
import { useAuth } from "../../contexts/AuthContext";
import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";
import { logout } from "../../services/authService";

export default function useUsuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const { userInfo } = useAuth();
  const [totalCount, setTotalCount] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    type: 'confirm',
    message: '',
    onConfirm: null
  });

  const listarUsuarios = async (page = 1, pageSize = 20) => {
    try {
      const response = await api.usuario.getAll(page, pageSize);

      const payload = response?.data || response || {};

      setTotalCount(payload.totalCount || 0);
      setUsuarios(payload.items || []);
    } catch (error) {
      alert(error.response);
    }
  };

  const excluirUsuario = async (id, email, page) => {
    const isCurrentUser =  userInfo?.id === id;

    setModalConfig({
      type: 'confirm',
      message: isCurrentUser ? 'Você tem certeza que deseja deletar a sua própria conta?' : `Deseja realmente excluir o usuário "${email}"?`,
      onConfirm: async () => {
        try {
          await api.usuario.delete(id, userInfo.id);

          setModalConfig({
            type: 'success',
            message: 'Usuário excluído com sucesso!',
            onConfirm: null
          });

          if(isCurrentUser) {
            // Se o usuário deletou a própria conta, fazer logout
            setTimeout(async () => {
              setShowModal(false);
              await logout();
            }, 2000);
          } else {
          listarUsuarios(page);
          }
          setTimeout(() => setShowModal(false), 2000);

        } catch (error) {

          let message = error.response?.data?.message 
              || 'Erro ao excluir usuário';

          if (error.response?.status === 403) {
            message = "Você não tem permissão para essa ação.";
          }

          setModalConfig({
            type: 'error',
            message: message,
            onConfirm: null
          });
        }
      }
    });

    setShowModal(true);
  };

  return { 
    usuarios, 
    totalCount, 
    listarUsuarios, 
    excluirUsuario,
    ModalComponent: (
      <ConfirmModal
        show={showModal}
        type={modalConfig.type}
        message={modalConfig.message}
        onClose={() => setShowModal(false)}
        onConfirm={modalConfig.onConfirm}
      />
    )
  };
}